import { motion } from "framer-motion";
import {
    Heart, Home, Utensils, Compass, DollarSign, BookOpen,
    Sparkles, Users, Baby, HandHeart, Handshake, Tent,
} from "lucide-react";

const MODULES = [
    { key: "prayer_journal", label: "Prayer Journal", desc: "A deeper, tagged prayer companion with reminders.", icon: HandHeart, status: "Available soon" },
    { key: "palm", label: "Palm Movement", desc: "Gentle, biblical rhythms for your body's stewardship.", icon: Heart, status: "In cultivation" },
    { key: "home", label: "Home Stewardship", desc: "Sanctuary rhythms, seasonal reset guides, hospitality.", icon: Home, status: "In cultivation" },
    { key: "meal", label: "Meal Planning", desc: "Nourishment as worship. Simple weekly plans.", icon: Utensils, status: "In cultivation" },
    { key: "calling", label: "Calling Discovery", desc: "Uncover the gifts and callings entrusted to you.", icon: Compass, status: "In cultivation" },
    { key: "finance", label: "Financial Stewardship", desc: "Wisdom, generosity, margin—money as garden.", icon: DollarSign, status: "In cultivation" },
    { key: "bible", label: "Bible Study", desc: "Guided studies grounded in the whole story.", icon: BookOpen, status: "In cultivation" },
    { key: "mentor", label: "AI Mentor", desc: "A tender companion to walk with you between seasons.", icon: Sparkles, status: "Roots forming" },
    { key: "family", label: "Family Dashboard", desc: "Everyone's gardens in one gentle view.", icon: Users, status: "Roots forming" },
    { key: "children", label: "Children's Stewardship", desc: "Age-appropriate cultivation for the little ones entrusted.", icon: Baby, status: "Roots forming" },
    { key: "marriage", label: "Marriage Dashboard", desc: "Two gardens joined into one flourishing whole.", icon: Handshake, status: "Roots forming" },
    { key: "retreat", label: "Retreat Planning", desc: "Sacred pauses—weekends and seasons of soul rest.", icon: Tent, status: "Roots forming" },
];

export default function Modules() {
    return (
        <div className="space-y-16">
            <header className="max-w-3xl">
                <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-4">The EDEN ecosystem</div>
                <h1 className="font-serif text-5xl md:text-7xl leading-[1.02]">A garden that keeps growing.</h1>
                <p className="mt-6 text-muted-foreground text-lg leading-relaxed">
                    These modules will unfold into EDEN over time. Each one is being cultivated
                    with the same care as the Blueprint you already have.
                </p>
            </header>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
                {MODULES.map((m, i) => {
                    const Icon = m.icon;
                    return (
                        <motion.div
                            key={m.key}
                            initial={{ opacity: 0, y: 12 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: i * 0.03 }}
                            className="hairline rounded-md p-6 hover:border-foreground/25 transition-colors"
                            data-testid={`module-${m.key}`}
                        >
                            <Icon className="w-5 h-5 text-[hsl(var(--eden-gold))]" strokeWidth={1.5} />
                            <div className="font-serif text-2xl mt-4">{m.label}</div>
                            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{m.desc}</p>
                            <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mt-6">
                                {m.status}
                            </div>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
}
